module.exports = __webpack_public_path__ + "img/manual.1c009a71.png";